import { baseApi } from "@/redux/api/baseApi";

const OrderVideoStatusApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getOrderVideoStageStatus: builder.query({
      query: ({ orderId, videoId }) => ({
        url: `/order-video-stage-status/get-status/${orderId}/${videoId}`,
        method: "GET",
      }),
      providesTags: (_result, _error, { orderId, videoId }) => [
        { type: "OrderVideoStage" as const, id: `${orderId}-${videoId}` },
      ],
    }),
  }),
});

export const {
    useGetOrderVideoStageStatusQuery
  
} = OrderVideoStatusApi;
